import { gql } from '@/__generated__/gql'

export const ContentAssetReferenceDeleteMutation = gql(`
  mutation ContentAssetReferenceDeleteMutation($contentAssetReference: ContentAssetReferenceDeleteInput!) {
    contentAssetReferenceDelete(contentAssetReference: $contentAssetReference) {
      success
    }
  }
`)
